import { AtlassianJiraConfluenceGridController } from '../controller/AtlassianJiraConfluenceGridController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';

export class AtlassianJiraConfluenceGridWebComponent extends BaseWebComponentElement {
  public controller: AtlassianJiraConfluenceGridController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AtlassianJiraConfluenceGridController,
    });
  }
}
